import React, { useState, useEffect } from "react";
import { Button, Image } from "../../ui";
import { useNavigate } from "react-router-dom";
import {
  useFetchProfilesQuery,
  useFetchAllPaymentQuery,
} from "../../store/api/apiSlice";
import CustomModal from "../customModal/customModal";
import swal from "sweetalert";
const Membership = ({ signupMode = false }) => {
  const {
    data: profileData,
    refetch: refetchProfileData,
    isLoading,
  } = useFetchProfilesQuery();
  const { data: Payments } = useFetchAllPaymentQuery();

  const lastSuccessPaymentDate = new Date(
    profileData?.user?.payment?.last_success_payment
  );
  const dueDate = new Date(lastSuccessPaymentDate);
  dueDate.setFullYear(lastSuccessPaymentDate.getFullYear() + 1);
  const formattedDueDate = dueDate.toLocaleDateString();
  const [openModal, setOpenModal] = useState(false);
  const email = profileData?.user.email;
  const firstName = profileData?.user.firstName;
  const lastName = profileData?.user.lastName;

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/");
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const openViewModal = () => {
    setOpenModal(true);
  };
  const handlePaymentPage = (e, priceId, product) => {
    e.stopPropagation();

    navigate("/payment", {
      state: { priceId, email, firstName, lastName, product },
    });
  };
  useEffect(() => {
    if (profileData) {
      if (!profileData.user.isPaid) {
        const createdAt = new Date(profileData.user.createdAt);
        const today = new Date();
        const trialPeriod = 10;
        const daysDiff = Math.floor(
          (today - createdAt) / (1000 * 60 * 60 * 24)
        );
        const daysLeft = trialPeriod - daysDiff;

        if (!profileData.user.isPaid) {
          if (daysLeft > 0) {
            swal({
              title: "",
              text: `You have ${daysLeft} days of trial period left. Please buy membership to have uninterrupted services.`,
              timer: 5000,
            });
          }
        }
      }
    }
  }, [profileData]);
  return (
    <div className="pricing-page">
      <div className="container">
        <div className="title-section membership_Title_section">
          <Image
            className="membership_title_image"
            path="/images/headericon.png"
            alt="Logo"
          />
          <h2 className="pb-0">College Sports Fan Association</h2>
        </div>

        <div className="pricing-grid">
          {Payments?.stripe_products
            .filter((product) => product.active)
            .map((product) => (
              <div key={product?.id} className={`pricing-card popular `}>
                <div className="card-content">
                  <h3 className="membership_productName">{product?.name}</h3>
                  <div className="price">
                    {product?.pricing_list.map((price) => (
                      <div key={price.id}>
                        <span className="amount">
                          ${(price?.unit_amount / 100).toFixed(2)}
                        </span>
                        <span className="period">/ year</span>
                      </div>
                    ))}
                  </div>
                  <ul className="features">
                    <li>{product?.description}</li>
                  </ul>

                  {isLoading ? (
                    <Button className="btn-secondary membership_btn" style={{width:"fit-content"}}>
                      Loading...
                    </Button>
                  ) : profileData && profileData.user.isPaid ? (
                    <>
                      <h3>You Already Subsrcribed</h3>
                      <Button
                        className="btn-secondary membership_btn"
                        onClick={openViewModal}
                        style={{width:"fit-content"}}
                      >
                        Check Detail
                      </Button>
                    </>
                  ) : (
                    product.pricing_list.map((price) => (
                      <Button
                        key={price.id}
                        onClick={(e) => handlePaymentPage(e, price.id, product)}
                        className="btn-secondary membership_btn"
                        style={{width:"fit-content"}}
                      >
                        Become a member
                      </Button>
                    ))
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
      {!signupMode && (
        <Button
          onClick={handleBackClick}
          className="btn-primary membership_btn_primary"
          style={{marginTop:"20px"}}
        >
          Back
        </Button>
      )}
      <CustomModal isOpen={openModal} onClose={closeModal}>
        <h3 className="membership_pkg_text">Package Details</h3>
        <div>
          {profileData?.user?.isPaid ? (
            <>
              <p>
                <strong>Package Name:</strong>{" "}
                {profileData?.user?.payment?.package_name}
              </p>
              <p>
                <strong>Amount:</strong> $
                {profileData?.user?.payment?.payment_history[0]?.amount / 100}{" "}
                USD
              </p>
              <p>
                <strong>Last Payment Date:</strong>{" "}
                {new Date(
                  profileData?.user?.payment?.last_success_payment
                ).toLocaleString()}
              </p>
              <p>
                <strong>Next Due Date:</strong> {formattedDueDate}
              </p>
            </>
          ) : null}
        </div>
      </CustomModal>
    </div>
  );
};

export default Membership;
